// extracted by mini-css-extract-plugin
module.exports = {"ph2":"gridgallery_ph2__2kUM5","gg4":"gridgallery_gg4__iU75o","gc3":"gridgallery_gc3__vPyuc","grid":"gridgallery_grid__1PZeA"};